import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreatePrestacionCUME = () => {
  const [loadingCreatePrestacionCUME, setLoadingCreatePrestacionCUME] = useState(false);
  const [successCreatePrestacionCUME, setSuccessCreatePrestacionCUME] = useState(false);
  const [errorCreatePrestacionCUME, setErrorCreatePrestacionCUME] = useState(null);
  const [dataCreatePrestacionCUME, setDataPrestacionCUME] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";

  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  );

  // CREATE
  const createPrestacionCUME = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreatePrestacionCUME(true);
    setSuccessCreatePrestacionCUME(false);
    setErrorCreatePrestacionCUME(null);

    apiRecord.newPrestacionEconomicaCUME(userId, data)
      .then((res: any) => {
        setLoadingCreatePrestacionCUME(false);
        setSuccessCreatePrestacionCUME(true);
        setDataPrestacionCUME(res.data);
        _cb?.(res.data);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingCreatePrestacionCUME(false);
        setErrorCreatePrestacionCUME(err.response?.data);
      });
  };

  return {
    createPrestacionCUME,
    loadingCreatePrestacionCUME,
    successCreatePrestacionCUME,
    errorCreatePrestacionCUME,
    dataCreatePrestacionCUME
  };
};

export default useCreatePrestacionCUME;
